import { Component, Input, NgZone, ChangeDetectorRef, Inject, ViewEncapsulation, ChangeDetectionStrategy, Optional, Self, ElementRef } from '@angular/core';
import { EnpsControl } from '@common/controls/enps-control/enps-control';
import { TimeoutQueue } from '@common/services/timeout-queue';
import { AppService } from '@suite/app.service';
import { GlobalTablesService } from "@common/services/global-tables-service";
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
    selector: 'text-field',
    templateUrl: './text-field.html',
    styleUrls: ['./text-field.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'st-text-field',
    }
})
export class TextField extends EnpsControl<string | number> {

    @Input() type: 'text' | 'password' | 'number' = 'text';
    @Input()
    get showLinks() {
        return this._showLinks;
    }
    set showLinks(value: BooleanInput) {
        this._showLinks = coerceBooleanProperty(value);
        if (this._showLinks) {
            this.inEditMode = false;
        }

    }
    private _showLinks = false;


    @Input()
    textToHighlight: string;

    get displayValue(): string {
        return this.value as string || this.placeholder || '';
    }

    inEditMode: boolean = true;

    constructor(
        appService: AppService,
        ngZone: NgZone,
        changeDetectorRef: ChangeDetectorRef,
        timeoutQueue: TimeoutQueue,
        globalTablesService: GlobalTablesService,
        elmRef: ElementRef,

    ) {
        super(appService, ngZone, changeDetectorRef, timeoutQueue, globalTablesService, elmRef);
    }

    keyPressed(event) {
        if (event.keyCode == 27) {
            this.elmRef.nativeElement.querySelector('input').blur();
            this.inEditMode = false;
        }
    }

    onNgModelChanged(value: string | number) {
        this.value = value;
    }

    onValueChanged() {
        this.changed.emit(this.value);
        if (this.showLinks && !this.disabled) {
            this.inEditMode = false;
        }
    }

    onBlur(event) {
        if (this.showLinks && !this.disabled) {
            this.inEditMode = false;
        }
    }


    onFocus(event) {
        if (this.showLinks && !this.disabled) {
            this.inEditMode = true;
        }
    }
}
